import {Outlet} from 'react-router-dom';
import React from 'react';
import { isBearerTokenAuthEnabled } from '../shared/utils/auth/auth';
import {RouteKey} from "./AppRoutes";

interface ProtectedLayoutProps {
  redirectTo?: string;
}

function BearerTokenGuardedRoute({ redirectTo }: ProtectedLayoutProps) {

  return <Outlet />
}

export function RouteGuardAuthorizedKeycloak({
  redirectTo
}: ProtectedLayoutProps) {
  const isMandantConfig = location.pathname === RouteKey.NewMandant;

  if (isBearerTokenAuthEnabled() && isMandantConfig) {
    return  <BearerTokenGuardedRoute redirectTo={redirectTo} />;
  }

  return <Outlet />;
}
